import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useProductUsageAttributeStore } from "../../hooks/useProductUsageAttributeStore";
import { ProductUsageAttributeModal } from "./components/ProductUsageAttributeModal";
import CategoryIcon from '@mui/icons-material/Category';
import { SpecificUsesModal } from "./components/SpecificUsesModal";
import { SelectProductsModal } from "./components/SelectProductsModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const ProductUsageAttributesView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionProductUse, getProductUsageAttribute, getProductUsageAttributeByCompany, deleteProductUsageAttribute } = useProductUsageAttributeStore();

    const [loading, setLoading] = useState(false);
    const [attributes, setAttributes] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalUseSpecific, setShowModalUseSpecific] = useState<boolean>(false);
    const [showModalProduct, setShowModalProduct] = useState<boolean>(false)
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [filter, setFilter]= useState<any>([]);
    const [productsSelected, setProductsSelected] = useState<any>([]);

    useEffect(() => {
        getProductUseApi()
    },[])

    const getProductUseApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getProductUsageAttributeByCompany(search);
            if(!response){
                setAttributes([]);
                setLoading(false);
                return false;
            }else{
                setAttributes(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionProductUse('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionProductUse('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionProductUse('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionProductUse('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const showUsesSpecifc = (rowSelected) => {
        setRowSelected(rowSelected);
        setShowModalUseSpecific(true);
    }

    const showSelectProducts = (rowSelected) => {
        setRowSelected(rowSelected);
        setShowModalProduct(true)
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteProductUsageAttribute(rowSelected.id)
            if(response){
                getProductUseApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getProductUseApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Atributos de uso de producto'}
                    columns={columns} 
                    loading={loading}
                    rows={attributes || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva uso'}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onHelper={showUsesSpecifc}
                    onCustomAction={showSelectProducts}
                    icon_helper={ <CategoryIcon fontSize="small" /> }
                    tooltip_helper={'usos específicos'}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <ProductUsageAttributeModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        productUseSelected = {rowSelected}
                        listProductUse = {getProductUseApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalUseSpecific && (
                    <SpecificUsesModal
                        open={showModalUseSpecific}
                        closeModal={()=>{ setShowModalUseSpecific(false)}}
                        useSelected = {rowSelected}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalProduct && 
                    <SelectProductsModal
                        open = {showModalProduct}
                        closeModal = {() => {setShowModalProduct(false)}}
                        clearState = {clearState}
                        rowSelected = {rowSelected}
                        setProductsSelected = {setProductsSelected}
                    />
            }
        </>
    )
}